export const CANNED_RESPONSE_AUTOTAGS_RELEASE_DATE = '2023-07-18';
